export default "__VITE_ASSET__DfhuJ3yW__"